import type { FunctionComponent } from 'react';
import { Ratings as RatingsTamagoshi } from '@/core/tamagoshi/Ratings/Ratings';
import { translateFormatter } from '@/domains/core/localization/translate';
import styles from './Ratings.module.scss';
export const ratingCountLabel = translateFormatter([{
  "type": 1,
  "value": "count"
}, {
  "type": 0,
  "value": " and more"
}], undefined, undefined, "en");
export interface RatingsProps {
  value: 3 | 4;
}
export const Ratings: FunctionComponent<RatingsProps> = ({
  value
}) => <div className={styles.root}>
    <RatingsTamagoshi nbStars={value} size="sm" className={styles.ratings} starsClassName={styles.stars} />
    {ratingCountLabel.format({
    count: value
  })}
  </div>;
Ratings.displayName = 'Ratings';